import { forwardRef } from 'react';
import { Link, useLocation } from 'react-router';
import { resolveNavAction } from './resolveNavAction';
/**
 * Exactly the same as React Router's {@link Link} except the `to` prop can be a
 * {@link NavAction}.
 *
 * @see {@link NavAction}'s doc comment for example usage.
 */
export const LinkNavAction = forwardRef(
// eslint-disable-next-line @typescript-eslint/no-shadow
function LinkNavAction({
  to: navAction,
  ...other
}, forwardedRef) {
  return <Link {...other} ref={forwardedRef} {...resolveNavAction(useLocation(), navAction)} />;
});